import logger from '@utils/logger';
import { usePutZoneMapConfigMutation } from 'src/graphql/generated/graphql';

const usePutZoneMapConfig = () => {
  const { mutate, mutateAsync, isError, isLoading, isSuccess, data } = usePutZoneMapConfigMutation({
    onError: (error) => {
      let loggedError: Error = Error('putZoneMapConfig failed');
      if (error instanceof Error) {
        loggedError = error;
      }
      void logger.error('Call to putZoneMapConfig resulted in error', loggedError);
    },
    onSuccess: (response) => {
      const { error } = response.putZoneMapConfig;
      if (error) {
        void logger.error('Call to putZoneMapConfig resulted in error', error);
      } else {
        void logger.info('Zone map config saved successfully');
      }
    },
  });

  const { error } = data?.putZoneMapConfig ?? {};
  return {
    mutate,
    mutateAsync,
    isError,
    isLoading,
    isSuccess,
    error,
  };
};

export default usePutZoneMapConfig;
